import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';

import { joinClasses } from 'utils/utils';
import { scale } from 'utils/math';

import ShareIcons from 'components/shareIcons/shareIcons';

import s from 'components/newsletter/newsletter.sss';

export default class Newsletter extends Component {

	constructor(props) {
		super(props);
		this.state = {
			formState: 'show',
			formError: false,
			formErrorMessage: '',
			checkedConsent: false
		};
		this.onScroll = this.onScroll.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		if (!CSS.supports('animation-timeline: --works')) {
			window.addEventListener('scroll', this.onScroll);
			this.onScroll();
		}
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
	}

	onScroll() {
		// Fallback if scroll-driven animations are not supported
		// const style = getComputedStyle(this.base);
		const rect = this.base.getBoundingClientRect();
		const pageHeight = document.documentElement.clientHeight;
		// entry min(50%, 100% - var(--earth-height))
		// const from = Math.min(rect.height / 2, rect.height - Math.round(parseFloat(style.paddingBottom)));
		// entry 0%
		const from = 0;
		// contain 50%
		const to = Math.min(pageHeight / 2 + rect.height / 2, pageHeight);
		const position = pageHeight - rect.top;
		this.revealProgress = scale(position, from, to, 0, 1, true, 'quadOut');
		this.base.style.setProperty('--reveal-progress', this.revealProgress);
	}

	isValidEmail(email) {
		const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		return emailRegex.test(email);
	}

	async onSubmit(e) {
		e.preventDefault();
		const { appData } = Store.get();
	
		Store.emit(actions.FORM_SUBMIT_CLICK);

		const emailAddress = e.target.elements.email.value;
		const name = e.target.elements.name.value;

		if (!emailAddress) {
			return;
		}
		if (!this.isValidEmail(emailAddress)) {
			this.setState({ formState: 'show', formError: true, formErrorMessage: appData?.copy?.baseCopy?.$NEWSLETTER_FORM_INVALID_EMAIL || 'Please enter a valid email address' });
			return;
		}

		if (this.state.formState !== 'show') return;

		if (!this.state.checkedConsent) {
			this.setState({
				formState: 'show',
				formError: true,
				formErrorMessage: appData?.copy?.baseCopy?.$NEWSLETTER_FORM_NO_CONSENT || 'You must agree to continue.'
			});
			return;
		}

		this.setState({ formState: 'submitting', formErrorMessage: '' });

		// const URL = 'https://dev.salesforce-service.cmspow.com';
		const URL = 'https://salesforce.api.universalpictures.com';
		try {
			const res = await fetch(URL, {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams({
					firstName: name,
					email: emailAddress,
				})
			});
			const data = await res.json();
			if (!data.success) {
				throw new Error('Invalid response');
			}
			Store.emit('SUBMIT_SALESFORCE_FORM');
			this.setState({ formState: 'success' });
		} catch (e) {
			this.setState({ formState: 'show', formError: true, formErrorMessage: appData?.copy?.baseCopy?.$NEWSLETTER_FORM_ERROR || 'An error occured. Try again later.' });
		}
	}

	render() {
		const formState = this.state.formState;

		return (
			<div class={joinClasses(s.container, this.state.revealed && s.revealed)} style={!!this.revealProgress && `--reveal-progress: ${this.revealProgress}`}>
				<div class={s.content}>
					<h2 class={s.title}>Stay Updated</h2>
					<div class={s.cta}>Sign up now for exclusive giveaways, advance screenings, sneak-peeks and other offers from NBCUniversal</div>
					<form class={joinClasses(s.form, s[`form-state-${formState}`])} onSubmit={this.onSubmit}>
						<h3 class={s.sectionName}>EMAIL NEWSLETTER</h3>
						<div class={s.stack}>
							<div class={s.submit} inert={formState === 'success'}>
								<label class={s.label}>Email address</label>
								<input class={s.input} type="email" name="email" placeholder="Your email" maxLength={254} required />
								<label class={s.label}>First name <span>(optional)</span></label>
								<input class={s.input} type="text" name="name" placeholder="Your name" maxLength={300} />
								<label class={s.checkbox}>
									<input
										type="checkbox"
										name="consent"
										checked={this.state.checkedConsent}
										onChange={(e) => this.setState({ checkedConsent: e.target.checked })}
									/>
									<div>By checking this box you agree to our <a href="https://www.nbcuniversalprivacy.com/privacy?intake=Universal_Pictures" target="_blank">Privacy Policy</a> and <a href="https://www.nbcuniversal.com/terms" target="_blank">Terms of Service</a></div>
								</label>
								<button class={s.button} type="submit" disabled={formState !== 'show'}>SUBSCRIBE</button>
								{!!this.state.formError && <div class={s.formError}>{this.state.formErrorMessage}</div>}
							</div>
							<div class={s.success}>
								Thank you for subscribing, we will send you updates soon.
							</div>
						</div>
					</form>
					<div class={s.share}>
						<h3 class={s.sectionName}>FOLLOW US</h3>
						<ShareIcons class={s.shareIcons} id="subscribe" />
					</div>
				</div>
			</div>
		);
	}

}